import { Sentry } from '@/lib/sentry';

type LogLevel = 'warn' | 'error';

function log(level: LogLevel, message: string, ...args: unknown[]): void {
  if (level === 'error') {
    console.error(message, ...args);
    const err = args.find(a => a instanceof Error) as Error | undefined;
    if (err) {
      Sentry.captureException(err, { extra: { message } });
    } else {
      Sentry.captureMessage(message, 'error');
    }
  } else {
    console.warn(message, ...args);
  }
}

export const logger = {
  warn:  (message: string, ...args: unknown[]) => log('warn',  message, ...args),
  error: (message: string, ...args: unknown[]) => log('error', message, ...args),
};
